/* eslint-disable react/jsx-key */
import React, { useRef, useState, useEffect } from 'react';
import Styles from './ModalSeguros.css';
import WhiteButton from '@/components/atoms/WhiteButton';

function ModalSeguros({ docs = [], setShowModal, linkBaixarTodos, tituloModal }) {
  // useEffect(() => {
  //   if (setShowModal) {
  //     document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
  //   } else {
  //     document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
  //   }
  // }, [setShowModal]);

  return (
    <section id="modal-seguros">
      <div className="modal">
        <div
          onClick={() => {
            setShowModal(false);
          }}
          className="close-modal"
        >
          <img src="assets/shared/close-modal-seguros.svg" alt="" />
        </div>
        <p className="modal-seguros-titulo">{tituloModal}</p>
        <div className="modal-seguros-docs">
          <>
            {docs.map((doc) => (
              <a href={doc.link} target="_blank" className="modal-seguros-doc">
                <div className="modal-seguros-doc-infos">
                  <img src="assets/shared/ic_file_pdf_black.svg" alt="" />
                  <div className="modal-seguros-doc-textos">
                    <p className="modal-seguros-doc-titulo">{doc.titulo}</p>
                    <p className="modal-seguros-doc-descricao">{doc.descricao}</p>
                  </div>
                </div>
                <p className="modal-seguros-doc-baixar">Baixar</p>
              </a>
            ))}
          </>
        </div>
        <div
          className="btn-baixar-todos"
          style={{
            visibility: linkBaixarTodos ? 'visible' : 'hidden',
          }}
        >
          <WhiteButton href={linkBaixarTodos} target="_blank">
            Baixar todos
          </WhiteButton>
        </div>
      </div>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default ModalSeguros;
